// extracted by mini-css-extract-plugin
export default {"container":"styles_container__w5Pmn","headertext":"styles_headertext__+Z39a","contentMain":"styles_contentMain__6exkC","textOne":"styles_textOne__ZfXda","img":"styles_img__qLJld"};